import { apiFactorsList } from "api/factorApi";
import BasicDateInput from "components/BasicInputs/BasicDateInput";
import { DateToString } from "components/Reports/DateFilter";
import ContainedTabs from "components/Tabs/Tabs3";
import { useFormikContext } from "formik";
import { DateObject } from "react-multi-date-picker";
import { useAppDispatch, useAppSelector } from "../../../store/store";

export default function TabsSection() {
  const data = useFormikContext<InstallmentData>();
  const store = useAppSelector((x: any) => x);
  const token = store.businessReducer.business.token;
  const dispatch = useAppDispatch();
  const refreshData = (value: number) => {
    data.setFieldValue("description", "");
    data.setFieldValue("factorId", undefined);
    data.setFieldValue("personId", undefined);
    if (data.values.type === "factor") {
      let factorType = "";
      if (value === 0) {
        factorType = '["sale"]';
      } else {
        factorType = '["buy"]';
      }
      
      dispatch(apiFactorsList(token, factorType, "installment"));
    }
  };

  return (
    <div className="flex flex-wrap items-center justify-between gap-4 p-4">
      <ContainedTabs
        tabs={[
          { label: "دریافتی", activeColor: "#1E8E1B" },
          { label: "پرداختی", activeColor: "#CB0B0B" },
        ]}
        onChange={(val) => {
          data.setFieldValue("tab", val);
          refreshData(val ?? 0);
        }}
        activeTab={data.values.tab || 0}
        size={2}
        minWidth={100}
      />
      <div className="flex items-center gap-2 min-w-[300px]">
        <span className="whitespace-nowrap">تاریخ ثبت:</span>
        <BasicDateInput
          styles={{ inputWrapper: { border: "none" } }}
          defaultValues={[data.values.date || DateToString(new Date(Date.now()))]}
          customView={(values: DateObject[]) => {
            if (!values || !values[0]) return;
            const date = values[0];
            return (
              <div className="flex flex-row-reverse items-center gap-2 text-base text-slate-500">
                <span>{date.year}</span>
                <span>/</span>
                <span className="text-slate-400">( {date.month.name} )</span>
                <span>{date.month.number}</span>
                <span>/</span>
                <span>{date.day}</span>
              </div>
            );
          }}
        />
      </div>
    </div>
  );
}
